import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT

//导出excel 董跃 2018-12-15
export const exportExcel = (params, title) => {
  axios.post(root + '/api/excel/exportexcel', qs.stringify(params), {responseType: "blob"}).then(response => {
    exportFile(response.data, title, '.xls')
  })
}

//导出pdf 董跃 2019-4-22
export const exportPdf = (params, title,viewonline) => {
  axios.post(root + '/api/pdf/exportpdf', qs.stringify(params), {responseType: "blob"}).then(response => {
    exportFile(response.data, title, '.pdf',viewonline)
  })
}

export const barcodePrint=(barcode,erpserial,printtype) => {
  if(printtype==null) printtype='';
  if (erpserial) {
    window.open(root + '/api/pdf/barcodePrint?erpserial=' + erpserial + '&tenantid=' + JSON.parse(localStorage.getItem("hpapi_userInfoModel")).tenantid+'&printtype='+printtype)
  } else {
    if (!barcode)
      return;

    //if (barcode.length > 100) {
    axios.post(root + '/api/pdf/saveStoreprint', qs.stringify({opcontent: JSON.stringify(barcode)})).then(response => {
      window.open(root + '/api/pdf/barcodePrint?unitguid=' + response.data.msg+'&printtype='+printtype)
    })
    // } else {
    //   window.open(root + '/api/pdf/barcodePrint?barcodes=' + JSON.stringify(barcode))
    // }
  }
}

//导出文件流  董跃 2018-12-15
function exportFile(data, title, extensionName,viewonline) {
  let now = new Date()
  now = now.getFullYear() + "-" + (now.getMonth() < 9 ? '0' : '') + (1 + now.getMonth()) + "-" + (now.getDate() < 10 ? '0' : '') + now.getDate()
  // const blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'})
  const blob = new Blob([data], {type: "application/octet-stream"})
  const href = window.URL.createObjectURL(blob)
  if (extensionName == '.pdf'&&viewonline) {//在线预览   2019-4-25
    window.open("/static/pdf/web/viewer.html?file=" + href)
    setTimeout(() => {
      window.URL.revokeObjectURL(href)
    }, 1500)
  } else {//在线下载
    const downloadElement = document.createElement('a')
    downloadElement.href = href
    downloadElement.download = (title || now) + extensionName
    document.body.appendChild(downloadElement)
    downloadElement.click()
    document.body.removeChild(downloadElement)
    window.URL.revokeObjectURL(href)
  }

}





// WEBPACK FOOTER //
// ./src/api/file.js